import React, {useEffect, useRef} from 'react'
import Script from 'next/script'
import {Locale} from '@local/ui/components'

type ContactFormProps = {
	buttonRef: React.RefObject<HTMLButtonElement>;
	email: string;
	firstName: string;
	lastName: string;
	phoneNumber?: string;
	setStatus: (status: string) => void;
	privateExperience?: boolean;
	segmentID?: string;
};

const ContactForm = ({
	buttonRef,
	email,
	firstName,
	lastName,
	phoneNumber,
	setStatus,
	privateExperience,
	segmentID,
}: ContactFormProps) => {
	const ref = useRef<HTMLDivElement>(null)
	const id =
    segmentID ||
    (privateExperience ? '66718937725f8200c2dfb691' : '666b216928dc5382f304d58e')
	useEffect(() => {
		if (ref.current) {
			const observer = new MutationObserver((mutationsList) => {
				for (const mutation of mutationsList) {
					if (mutation.attributeName === 'data-ff-stage') {
						setStatus(ref.current?.getAttribute('data-ff-stage') || '')
					}
				}
			})

			observer.observe(ref.current, {
				attributes: true,
				attributeFilter: ['data-ff-stage'],
			})

			// Clean up the observer on component unmount
			return () => observer.disconnect()
		}
	}, [])

	return (
		<>
			<Script>
				{`window.fd('form:handle', {
					formId: '${id}',
				rootEl: '.ff-${id}',
				});`}
			</Script>
			<div className='w-full'>
				<div
					ref={ref}
					className={`ff-${id}`}
					data-ff-el='root'
					data-ff-version='3'
					data-ff-type='inline'
					data-ff-name='ribbonBanner'
					data-ff-stage='default'>
					<div
						data-ff-el='config'
						data-ff-config='eyJ0cmlnZ2VyIjp7Im1vZGUiOiJpbW1lZGlhdGVseSIsInZhbHVlIjowfSwib25TdWNjZXNzIjp7Im1vZGUiOiJyZWRpcmVjdCIsIm1lc3NhZ2UiOiIiLCJyZWRpcmVjdFVybCI6IiJ9LCJjb2kiOmZhbHNlLCJzaG93Rm9yUmV0dXJuVmlzaXRvcnMiOnRydWUsIm5vdGlmaWNhdGlvbiI6dHJ1ZX0='
						style={{display: 'none'}} />
					<div>
						<form
							action={`https://form.flodesk.com/forms/${id}/submit`}
							method='post'
							data-ff-el='form'>
							<div data-ff-el='content'>
								<div data-ff-el='fields'>
									<input
										className='hidden'
										id={`ff-${id}-firstName`}
										type='text'
										name='firstName'
										placeholder='First name'
										data-ff-tab='firstName::lastName'
										value={firstName} />
									<input
										className='hidden'
										id={`ff-${id}-lastName`}
										type='text'
										name='lastName'
										placeholder='Last name'
										data-ff-tab='lastName:firstName:email'
										value={lastName} />
									<input
										className='hidden'
										id={`ff-${id}-email`}
										type='text'
										name='email'
										placeholder='Email address'
										data-ff-tab='email:lastName:fields.phonenumber'
										value={email}
										required />
									{phoneNumber && (
										<input
											className='hidden'
											id={`ff-${id}-XBXcuLOLfF`}
											type='text'
											name='fields.phonenumber'
											placeholder='phoneNumber'
											data-ff-tab='fields.phonenumber:email:submit'
											value={phoneNumber} />
									)}{' '}
									<input
										className='hidden'
										type='text'
										name='confirm_email_address' />
								</div>
								<div className={`w-full ff-${id}__footer`} data-ff-el='footer'>
									<button
										type='submit'
										data-ff-el='submit'
										data-ff-tab='submit'
										ref={buttonRef}
										className='w-full hidden mt-auto'>
										<Locale>Subscribe</Locale>
									</button>
								</div>
							</div>
							<div
								className={`ff-${id}__error fd-form-error`}
								data-ff-el='error' />
						</form>
					</div>
				</div>
			</div>
		</>
	)
}

export default ContactForm
